import DetailForm from "./DetailForm";
import PasswordForm from "./PasswordForm";

export default {
  DetailForm,
  PasswordForm,
};
